import request from "superagent";
import Auth from "../routes/Auth";
import { reactLocalStorage } from "reactjs-localstorage";

class ApiService {
  allowAutoplay() {
    if (ApiService.isFirstLogin !== null) {
      return ApiService.isFirstLogin;
    }

    let is_first_login = reactLocalStorage.get("isFirstLogin", false);

    if (is_first_login === false) {
      reactLocalStorage.set("isFirstLogin", true);
    }

    if (ApiService.isFirstLogin === null) {
      ApiService.isFirstLogin = !is_first_login;
    }

    return ApiService.isFirstLogin;
  }

  getRequest(url, okCallback) {
    let token = Auth.getToken();

    let r = request.get(url).set("Accept", "application/json");

    if (token) {
      r = r.set("Authorization", `Token ${token}`);
    }

    if (okCallback) {
      r = r.ok(okCallback);
    }

    return r;
  }

  downloadRequest(url, contentType) {
    return fetch(url, {
      headers: {
        'Content-Type': contentType,
      },
    });
  }

  batchRequest(urls) {
    return Promise.all(
      urls.map(url => ApiService.prototype.getRequest(url))
    );
  }

  postRequest(url) {
    let token = Auth.getToken();

    let r = request.post(url).set("Accept", "application/json");

    if (token) {
      r = r.set("Authorization", `Token ${token}`);
    }

    return r;
  }

  loginRequest(data) {
    return request
      .post(`${process.env.REACT_APP_API_URL}api-token-auth/`)
      .set("Accept", "application/json")
      .send(data);
  }

  putRequest(url) {
    let token = Auth.getToken();

    let r = request
      .put(url)
      .set("Accept", "application/json")
      .set("Authorization", `Token ${token}`);

    return r;
  }

  patchRequest(url) {
    let token = Auth.getToken();

    let r = request
      .patch(url)
      .set("Accept", "application/json")
      .set("Authorization", `Token ${token}`);

    return r;
  }

  deleteRequest(url) {
    let token = Auth.getToken();

    let r = request
      .del(url)
      .set("Accept", "application/json")
      .set("Authorization", `Token ${token}`);

    return r;
  }
}

ApiService.isFirstLogin = null;

export const getRequest = ApiService.prototype.getRequest;
export const downloadRequest = ApiService.prototype.downloadRequest;
export const batchRequest = ApiService.prototype.batchRequest;
export const postRequest = ApiService.prototype.postRequest;
export const loginRequest = ApiService.prototype.loginRequest;
export const putRequest = ApiService.prototype.putRequest;
export const patchRequest = ApiService.prototype.patchRequest;
export const deleteRequest = ApiService.prototype.deleteRequest;
export const allowAutoplay = ApiService.prototype.allowAutoplay;



// WEBPACK FOOTER //
// ./src/api/ApiService.js